import { useDemoIdentity } from "../lib/DemoIdentityContext";
import { useTenantTerms } from "../lib/TenantConfigContext";
import SystemHealth from "./SuperAdmin/SystemHealth";
import "./SuperAdmin/superadmin-theme.css";

// System health for a brand's own logins: Templates, Group creation and Background
// jobs for the workshops their role reaches. The role needs the System health
// permission (Roles & access); the API checks it again and does the narrowing.
export default function SystemHealthPage() {
  const { role } = useDemoIdentity();
  const { canSeePage } = useTenantTerms();
  if (!canSeePage(role, "systemHealth")) {
    return <p className="p-8 text-[15px] text-[#6B7280]">System health isn&apos;t available for your role.</p>;
  }
  return (
    <div className="sa-scope">
      <SystemHealth admin={false} />
    </div>
  );
}
